import React from 'react';

import { makeHTMLFromString } from '../../utils';
import { TPostContentExpertBlockTheme } from '../../types/postContentExpertBlocks';
import * as s from './PostExpertBlock.css';

export interface IPostExpertBlock {
  text?: string;
  theme?: TPostContentExpertBlockTheme;
}

/**
 * Блок эксперта для поста
 */
export const PostExpertBlock = ({ text, theme = 'var(--theme-gray)' }: IPostExpertBlock) => {
  if (!text) {
    return null;
  }

  return (
    <div className={`${s['wrapper']} ${s[`_${theme}`]}`}>
      <div className={s['border']} />
      {/* eslint-disable-next-line react/no-danger */}
      {text && <div className={s['text']} dangerouslySetInnerHTML={{ __html: makeHTMLFromString(text).__html }} />}
    </div>
  );
};
